import { ref, computed, readonly, onUnmounted, unref } from 'vue';

/**
 * use countdown
 * @param {Number} count time
 */
export function useCountDown(count, config = {}) {
  const { frequency = 1000, immde = false } = config;
  const timer = ref();
  const number = ref(unref(count) * 1000);
  function stop() {
    clearTimeout(timer.value);
    timer.value = null;
  }
  function start() {
    stop();
    timer.value = setTimeout(() => {
      if (number.value <= 0) {
        return stop();
      }
      number.value -= frequency;
      start();
    }, frequency)
  }
  function reset() {
    stop();
    number.value = unref(count) * 1000;
  }
  function set(v) {
    number.value = v * 1000;
  }

  onUnmounted(() => {
    stop();
  })

  if (immde) start();

  return { start, stop, set, number, reset, state: computed(() => !!timer.value) }
}

export function toMinus(seconds) {
  return `${parseInt(seconds / 60, 10)}`.padStart(2, '0');
}
export function toSeconds(seconds) {
  return `${seconds % 60}`.padStart(2, '0');
}
